import formatButtons from './formatButtons';
import themeEditor from './themeEditor';

export default () => {
  formatButtons();
  themeEditor();
};